import { combineReducers } from 'redux';
import ApplicationState from './state';

export default combineReducers<ApplicationState>({
  empty: () => ({}),
});
